<template>
  <div class="container">
    <Tabs active-key="key1">
      <Tab-pane label="热门" key="key1">
        <div class="new-content">
          <div
            class="item"
            v-for="item of hotList"
            :key="item.id"
            @click="goDetail(item.id)"
          >
            <div class="left">
              <img :src="item.image_input[0]" alt="" />
            </div>
            <div class="middle"></div>
            <div class="right">
              <div class="name">{{ item.title }}</div>
              <div class="time">{{ item.add_time }}</div>
            </div>
          </div>
        </div>
      </Tab-pane>
      <Tab-pane label="行业资讯" key="key2">
        <div class="new-content">
          <div
            class="item"
            v-for="item of articleList"
            :key="item.id"
            @click="goDetail(item.id)"
          >
            <div class="left">
              <img :src="item.image_input[0]" alt="" />
            </div>
            <div class="middle"></div>
            <div class="right">
              <div class="name">{{ item.title }}</div>
              <div class="time">{{ item.add_time }}</div>
            </div>
          </div>
        </div>
      </Tab-pane>
      <Tab-pane label="企业动态" key="key3">
        <div class="new-content">
          <div
            class="item"
            v-for="item of companyList"
            :key="item.id"
            @click="goDetail(item.id)"
          >
            <div class="left">
              <img :src="item.image_input[0]" alt="" />
            </div>
            <div class="middle"></div>
            <div class="right">
              <div class="name">{{ item.title }}</div>
              <div class="time">{{ item.add_time }}</div>
            </div>
          </div>
        </div>
      </Tab-pane>
    </Tabs>
  </div>
</template>

<script>
import { getArticleHotList, getArticleList } from "@api/public";
export default {
  name: "News",
  data() {
    return {
      hotList: [],
      articleList: [],
      companyList: []
    };
  },
  created() {
    this.getArticleHotListInfo();
    this.getArticleListInfo(1);
    this.getArticleListInfo(2);
  },
  methods: {
    getArticleHotListInfo() {
      getArticleHotList().then(res => {
        this.hotList = res.data;
      });
    },
    goDetail(id) {
      this.$router.push({
        path: "/newsDetail/" + id
      });
    },
    getArticleListInfo(cid) {
      getArticleList({ page: 1, limit: 20 }, cid).then(res => {
        if (cid === 1) {
          this.articleList = res.data;
        } else {
          this.companyList = res.data;
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.container
  margin 20px 100px
  background #fff
  min-height 800px
  .new-content
    padding 10px
    display flex
    justify-content space-between
    flex-wrap wrap
    .item
      width 48%
      display flex
      margin-bottom 15px
      padding-bottom 15px
      border-bottom 1px solid #ededed
      cursor pointer
      .left
        width 100px
        height 100px
        img
          width 100%
          height 100%
      .right
        margin-left 20px
        .name
          font-size 16px
          color #666
          height 40px
        .time
          color #999
          margin-top 30px
</style>
